<div class="aw-modal" #modal>
  <ng-content></ng-content>
</div>
<div class="aw-modal-background" #modalBackground></div>
<!-- <div class="aw-modal-background second-background" *ngIf="modalOpenCount > 1"></div> -->